/**
 * A session cookie's value, when it is a token: never empty, and never `false`, which an app writes
 * in place of the session's cookies on the parent domain to sign the browser out. The one rule for it
 * in this app (stores/auth.ts). useCookie reads a value that parses as JSON as JSON, so a ref holds
 * that sign-out as the boolean, and a read of the jar as the string.
 */
export function tokenIn(value: unknown): string | null {
    return typeof value === 'string' && value !== '' && value !== 'false' ? value : null;
}
